import { format, parse } from 'date-fns';
import { fr } from 'date-fns/locale';
import { isNull } from 'lodash';

const possibleDateFormats = ['dd/MM/yyyy', 'MM-yyyy', 'yyyyMM', 'yyyy-MM-dd', 'MM/dd/yyyy', 'dd-MM-yyyy', 'yyyy/MM/dd'];

export const formatDate = (date, pattern = 'dd/MM/yyyy', options = { locale: 'fr' }) => {
  if (!date) return '';
  let validDate;

  if (isDateValid(date)) {
    validDate = new Date(date);
  } else {
    for (const formatString of possibleDateFormats) {
      const parsedDate = parse(date, formatString, new Date());
      if (isDateValid(parsedDate)) {
        validDate = parsedDate;
        break;
      }
    }
  }
  return format(validDate, pattern, { locale: options?.locale === 'fr' ? fr : null });
};

/*
  if date is null new Date() will return default date (1970-01-01T00:00:00.000Z)
  so if date is null we return false
*/
export const isDateValid = (date) => !isNull(date) && !isNaN(new Date(date));

/**
 *
 * @param {string} date Date dd/MM/yyyy format
 * @returns valid Date object
 */
export const getValidDate = (date) => {
  if (!date) return null;

  const dateParts = date.split('/');
  const newDate = dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2];
  return new Date(newDate);
};

export const getMonthYear = (date, pattern = 'MM-yyyy') => formatDate(date, pattern);

export const getShortMonth = (date) => formatDate(date, 'MMM');

/**
 * Converts a string from 'yyyyMM' format to 'MM-yyyy' format.
 * @param {string} dateString - The date string in 'yyyyMM' format.
 * @returns {string} - The formatted date string in 'MM-yyyy' format.
 */
export const convertDateString = (dateString) => {
  if (!dateString) return '';

  // Parse the string to a Date object
  const date = parse(dateString, 'yyyyMM', new Date());

  // Format the Date object to 'MM-yyyy'
  return format(date, 'MM-yyyy');
};
